import { IAutoAddingProduct } from '@/_types';
import { IProduct } from '@/entities/product/model/types';
import { Box, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import NeedRecProduct from './NeedRecProduct';

interface IProps {
  products: IAutoAddingProduct[] | undefined;
  productData: Record<string, IProduct> | undefined;
  shipperId: string;
  menuId: string;
  branchId: string;
  sourceId: string;
}

export default function NeedRecommend({
  products = [],
  productData,
  shipperId,
  menuId,
  branchId,
  sourceId,
}: IProps) {
  const t = useTranslations();

  return (
    <Box
      p={2}
      mx={{ base: 4, lg: 0 }}
      my={{ base: 6, lg: 0 }}
      bg='background.card'
      color='text'
      rounded={8}
      maxH='100%'
      h='max-content'
    >
      <Text as='p' fontSize={18} fontWeight={600} lineHeight={1.1} mb={5}>
        {t('need_product_title')}
      </Text>
      <Box maxH={{ base: 'auto', lg: '96px' }} overflowY='auto'>
        {products?.map((prod) => (
          <NeedRecProduct
            key={prod?.id}
            product={productData?.[prod?.product_id]}
            autoAddingProduct={prod}
            shipperId={shipperId}
            menuId={menuId}
            branchId={branchId}
            sourceId={sourceId}
          />
        ))}
      </Box>
    </Box>
  );
}
